import {handleActions as create} from 'redux-actions';

import * as types from './types';
import {ERROR_MESSAGE} from 'admin-ng/constants';

const initial = {
  error: null,
  filters: 'active',
  isDownloading: false,
  isFetching: false,
  limit: 20,
  offset: 0,
  search: '',
  sort: 'user.email',
  total: 0,
  users: [],
};

export const handlers = {
  [types.DOWNLOAD]: {
    next: (state, {payload: {isDownloading = false} = {}}) => ({
      ...state,
      error: null,
      isDownloading,
    }),
    throw: (state, {payload: {message: error}}) => ({
      ...state,
      isDownloading: false,
      error,
    }),
  },

  [types.FETCH]: {
    next: (state, {payload: {isFetching = false, ...payload} = {}}) => ({
      ...state,
      ...payload,
      error: null,
      isFetching,
    }),
    throw: (state, {payload: {message: error}}) => ({
      ...state,
      isFetching: false,
      error: error || ERROR_MESSAGE,
    }),
  },

  [types.SET_PARAMS]: (state, {payload: params}) => ({...state, ...params}),
  [types.RESET]: () => ({...initial}),
};

export default create(handlers, initial);
